import React from "react";
import instaIcon from "./../../assets/img/instagram.svg";
const InstagramIcon = () => {
  return <img src={instaIcon} alt="instagram icon" style={{ padding: 8 }} />;
};

export default InstagramIcon;
